import { createAsyncThunk } from "@reduxjs/toolkit";
import { updateVehiclesStateData } from ".";
import { RootState } from "../..";

export const updateVehicle = createAsyncThunk(
  "vehiclesState/updateVehicle",
  async (vehicleState: VehicleState, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const currentData = { ...state.vehiclesState.data };
    const { vehicle_id } = vehicleState;

    if (vehicle_id) {
      // Stamp arrival time so consumers (e.g. the map icon) can tell live
      // telemetry from a frozen last-known state. The initial `create`
      // snapshot is deliberately NOT stamped — it is last-known data from
      // Redis/Influx, not proof the vehicle is currently publishing.
      currentData[vehicle_id] = { ...vehicleState, received_at: Date.now() };
      thunkAPI.dispatch(updateVehiclesStateData(currentData));
    }
  }
);
